import { Helmet } from "react-helmet";
import { Img, Text, Heading } from "../../components";
import Header from "../../components/Header";
import Hero from "./Hero";
import Study from "./Study";
import AboutMe from "./AboutMe";
import React from "react";
import Projects from "./Projects";
import WorkExperience from "./WorkExperience";



export default function DesktopOnePage() {
  return (
    <>
      <Helmet>
        <title>Portfolio website</title>
        <meta name="description" content="Web site created using create-react-app" />
      </Helmet>
      <div className="flex w-full flex-col gap-11 bg-gray-900">
        <Header />
        <div className="mb-1 flex flex-col items-center gap-y-24">
          <Hero />
          <AboutMe />
          <Study />
          <WorkExperience />
          <Projects/>
        </div>
      </div>
    </>
  );
}
